import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

import { createPopper } from '@popperjs/core';
import { useRef, useEffect, useCallback, useState } from 'react';
export function usePositioner() {
  var popperJSRef = useRef(null);

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      position = _useState2[0],
      setPosition = _useState2[1];

  useEffect(function () {
    return function () {
      if (popperJSRef.current) {
        popperJSRef.current.destroy();
        popperJSRef.current = null;
      }
    };
  }, []);
  /**
   * Update the target element for the currently
   * displayed popover. This will reposition the popover
   * next to the newly provided target.
   */

  var updateTarget = useCallback(function (targetEl) {
    if (popperJSRef.current) {
      popperJSRef.current.state.elements.reference = targetEl;
      popperJSRef.current.update();
    }
  }, []);
  /**
   * Create popperJS instance and position your
   * popover by calling this function.
   */

  var positionPopover = useCallback(function (_ref) {
    var popoverRef = _ref.popoverRef,
        targetEl = _ref.targetEl,
        _ref$placement = _ref.placement,
        placement = _ref$placement === void 0 ? 'bottom' : _ref$placement,
        offset = _ref.offset,
        boundary = _ref.boundary,
        _ref$autoHide = _ref.autoHide,
        autoHide = _ref$autoHide === void 0 ? true : _ref$autoHide,
        applyStyles = _ref.applyStyles,
        _ref$enableGpuAcceler = _ref.enableGpuAcceleration,
        enableGpuAcceleration = _ref$enableGpuAcceler === void 0 ? true : _ref$enableGpuAcceler;

    if (popperJSRef.current) {
      popperJSRef.current.destroy();
      popperJSRef.current = null;
    }

    var modifiers = [{
      name: 'hide',
      enabled: autoHide
    }, {
      name: 'offset',
      options: {
        offset: offset
      }
    }, {
      name: 'eventListeners',
      options: {
        resize: true,
        scroll: true
      }
    }, {
      name: 'computeStyles',
      options: {
        gpuAcceleration: enableGpuAcceleration
      }
    }, {
      name: 'preventOverflow',
      options: {
        padding: 8,
        altAxis: true,
        boundary: boundary
      }
    }, {
      name: 'flip',
      options: {
        flipVariations: false
      }
    }, {
      name: 'arrow',
      options: {
        padding: 1
      }
    }, {
      name: 'updateState',
      enabled: true,
      phase: 'write',
      fn: function fn(_ref2) {
        var state = _ref2.state;
        setPosition(state.placement);
      },
      requires: ['computeStyles']
    }];

    if (applyStyles) {
      modifiers.push({
        name: 'applyStyles',
        enabled: true,
        fn: function fn(_ref3) {
          var state = _ref3.state;
          applyStyles(_objectSpread({}, state));
        }
      });
    } // create our popper using popperjs and hold its reference


    popperJSRef.current = createPopper(targetEl, popoverRef.current, {
      placement: placement,
      modifiers: modifiers
    });
  }, []);
  return {
    popperJSRef: popperJSRef,
    positionPopover: positionPopover,
    placement: position,
    updateTarget: updateTarget
  };
}